module.exports = __webpack_public_path__ + "img/icons-laboratory.6b7eb688.svg";